import { ModelBase } from 'store/model-base';

import { DeviceNetworkCompatibilityStatus } from 'my-account/constants';

export class DeviceNetworkCompatibility extends ModelBase {
    public static storeName: string = 'deviceNetworkCompatibility';

    public eligibilityStatus: DeviceNetworkCompatibilityStatus;
    public imei: string;

    public isCompatible: boolean;
    public isNotCompatible: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isNotCompatible = data.eligibilityStatus === DeviceNetworkCompatibilityStatus.NOT_COMPATIBLE;
        data.isCompatible = data.eligibilityStatus === DeviceNetworkCompatibilityStatus.COMPATIBLE;

        return super.create<T>(data);
    }
}
